import { Map } from 'ol';
import Feature, { FeatureLike } from 'ol/Feature';
import { toLonLat } from 'ol/proj';
import Overlay from 'ol/Overlay';
import { Point } from 'ol/geom';

export const clusterSourceDistance = 60; // distanza in pixel per raggruppare i marcatori

export const statoMarcatoreList = [
    { value: 1, label: 'Ottimo' },
    { value: 2, label: 'Buono' },
    { value: 3, label: 'Sufficiente' },
    { value: 4, label: 'Da controllare' },
    { value: 5, label: 'Non funzionante' },
];

export const tipoMarcatoreList = [
    { value: 1, label: 'Idrante soprasuolo' },
    { value: 2, label: 'Idrante sottosuolo' },
    { value: 3, label: 'Piazzola elicottero' },
    { value: 4, label: 'Bacino idrico' },
    { value: 5, label: 'Defibrillatore' },
    { value: 100, label: 'Punto di interesse' },
];

export type Content = {
    title: string;
    description: string;
    buttons:
        | Array<{
              label: string;
              href: string;
              newPage: boolean;
          }>
        | null
        | undefined;
};

/**
 * Crea un popup sulla mappa con il contenuto specificato.
 * @param map La mappa su cui aggiungere il popup.
 * @param feature Il feature associato al popup.
 * @param content Il contenuto del popup, che include titolo, descrizione e pulsanti.
 */
export function createPopUp(map: Map | undefined, feature: FeatureLike | undefined, content: Content): void {
    if (!map || !feature) {
        return;
    }

    const features = feature.get('features');
    const coordinate = (features[0].getGeometry() as Point).getCoordinates();

    // Rimuovi vecchi popup/overlay
    map.getOverlays().clear();

    const popupElement = document.createElement('div');
    popupElement.id = 'map-popup';
    popupElement.className = 'card';
    popupElement.style.minWidth = '250px';
    popupElement.style.maxHeight = '500px';
    popupElement.style.overflowY = 'auto';
    popupElement.style.zIndex = '1000';

    const contentElementArray = [];
    contentElementArray.push(`<div class="card-header">`);
    contentElementArray.push(`  <h5 class="mb-0">${content.title}</h5>`);
    contentElementArray.push(`</div>`);
    contentElementArray.push(`<div class="card-body">`);
    contentElementArray.push(content.description);
    if (content.buttons && content.buttons.length !== 0) {
        contentElementArray.push(`  <div class="mt-3 d-flex flex-column gap-2">`);
        content.buttons?.forEach((button) => {
            contentElementArray.push(
                `  <a class="btn btn-sm btn-primary" href="${button.href}"` +
                    ` target="${button.newPage ? '_blank' : '_self'}">${button.label}</a>`,
            );
        });
        contentElementArray.push(`  </div>`);
    }
    contentElementArray.push(`</div>`);
    popupElement.innerHTML = contentElementArray.join('');

    // Crea l'overlay e lo aggancia alla mappa
    const overlay = new Overlay({
        element: popupElement,
        positioning: 'bottom-center',
        stopEvent: true,
    });
    overlay.setPosition(coordinate);
    map.addOverlay(overlay);
}

/**
 * Crea i parametri per le coordinate del feature
 **/
export function getFeatureCoordinatesParams(map: Map | undefined, feature: Feature | undefined): string {
    if (!map || !feature) {
        return '';
    }

    const features = feature.get('features');
    const zoom = map.getView().getZoom();
    const center = map.getView().getCenter();
    const centerLatLon = toLonLat(center || [11, 46]);
    const centerLat = centerLatLon[1];
    const centerLon = centerLatLon[0];

    return `zoom=${zoom}&centerLat=${centerLat}&centerLon=${centerLon}`;
}
